import { useSelector } from "react-redux";

import { Box, Grid, Link, Typography } from "@mui/material";

const BasinData = ({ subheaderStyle, useMobileLayout }) => {
  const selectedRow = useSelector((state) => state.dataExplorer.selectedRow);

  return (
    <Grid
      item
      xs={12}
      md={useMobileLayout ? 12 : 8}
      sx={{ flexGrow: 1, overflowY: "auto" }}
    >
      <Box sx={{ width: "100%" }}>
        {selectedRow.row.sciencebase_url && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Basin Website
              <Typography>
                <Link
                  href={selectedRow.row.sciencebase_url}
                  sx={{
                    color: "#42a5f5",
                  }}
                  target="_blank" // opens link in new tab
                >
                  {selectedRow.row.sciencebase_url}
                </Link>
              </Typography>
            </Typography>
          </Box>
        )}
        {selectedRow.row.website_url && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Website URL
              <Typography>
                <Link
                  href={selectedRow.row.website_url}
                  sx={{
                    color: "#42a5f5",
                  }}
                  target="_blank" // opens link in new tab
                >
                  {selectedRow.row.website_url}
                </Link>
              </Typography>
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default BasinData;
